import { createContext, useContext, useState, useEffect } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);
export const LANGUAGES = [
  { code: "fr", label: "Français", flag: "FR" },
  { code: "en", label: "English", flag: "EN" },
  { code: "es", label: "Español", flag: "ES" },
];

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("gls_lang");
    return ["fr", "en", "es"].includes(saved) ? saved : "fr";
  });

  useEffect(() => {
    localStorage.setItem("gls_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => {
    const resolve = (dict) => key.split(".").reduce((acc, p) => (acc == null ? undefined : acc[p]), dict);
    return resolve(translations[lang]) ?? resolve(translations.fr) ?? key;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
